import { render, staticRenderFns } from "./AssignContractList.vue?vue&type=template&id=ed47de74&"
import script from "./AssignContractList.vue?vue&type=script&lang=js&"
export * from "./AssignContractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports